<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="customerListcard" :loading="loading">
          <v-data-table
            :headers="headers"
            :items="notificationList"
            :search="search"
            :itemsPerPage="50"
            sort-by="sendDate"
            :sort-desc="true"
            multi-sort
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Benachrichtigung suchen"
                class="pa-4"
                :outlined="true"
                :filled="true"
                :clearable="true"
                background-color="#e8eff7"
              ></v-text-field>
            </template>

            <template slot="item.status" slot-scope="{ item }">
              <v-chip
                small
                :color="item.status === 'sent' ? 'success' : 'orange'"
                >{{ item.status }}</v-chip
              >
            </template>

            <template slot="item.counts" slot-scope="{ item }">
              {{ item.successCount }} / {{ item.failedCount }}
            </template>

            <template slot="item.ownerCustomer" slot-scope="{ item }">
              {{ getCustomerName(item.ownerCustomer) }}
            </template>

            <template slot="item.sendDate" slot-scope="{ item }">
              {{ formatDate(item.sendDate) }}
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-icon
                v-if="item.status == 'draft' || item.status == 'scheduled'"
                small
                class="mr-2"
                @click="editItem(item)"
                >mdi-pencil</v-icon
              >
              <v-icon small class="mr-2" @click="askDelete(item)"
                >mdi-delete</v-icon
              >
              <v-icon small class="mr-2" @click="copyItem(item)"
                >mdi-content-copy</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dlgDelete" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Benachrichtigung löschen?</v-card-title>
        <v-card-text>
          Soll die Benachrichtigung wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteNotification">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  name: "NotificationList",
  data: () => ({
    loading: false,
    search: "",
    dlgDelete: false,
    deleteItem: false,

    headers: [
      { text: "Status", value: "status", width: "100px" },
      { text: "Empfangen / Fehlgeschlagen", value: "counts", width: "100px" },
      { text: "Sende Datum", value: "sendDate", width: "150px" },
      { text: "Titel", value: "title", width: "150px" },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "110px",
        align: "right"
      }
    ]
  }),
  components: {},
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    },
    userRole(item) {
      if (item.role == "superuser") return "Superuser";
      else if (item.role == "manager") return "System Admin";
      else if (item.role == "customer-admin") return "Kunden Admin";
      else if (item.role == "customer") return "Kunden Benutzer";
      else return item.role;
    },
    askDelete(item) {
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    editItem(item) {
      this.$router.push({
        name: "notification-edit",
        params: { id: item._id }
      });
    },
    copyItem(item) {
      let copyItem = { ...item };
      copyItem.title = `Copy ${copyItem.title}`;
      copyItem._id = null;
      copyItem.status = "draft";
      copyItem.sendDate = moment().format("YYYY-MM-DD");
      copyItem.sendTime = null;
      this.$store.commit("notification/SET_NOTIFICATION", copyItem);
      this.$store
        .dispatch("notification/saveNotification")
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Kopieren erfolgreich",
            text: "Benachrichtigung wurde kopiert"
          });
        })
        .catch(() => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Kopieren fehlgeschlagen",
            text: "Benachrichtigung konnte nicht kopiert werden."
          });
        });
    },

    getCustomerName(customerId) {
      if (customerId == "system") {
        return customerId;
      }

      const customer = this.$store.getters["customer/getCustomerList"].find(
        item => item._id === customerId
      );
      if (!customer) {
        return "Unknown Customer";
      }

      return (
        customer.name +
        " / " +
        customer.adresse +
        ", " +
        customer.plz +
        " " +
        customer.ort
      );
    },

    deleteNotification() {
      this.dlgDelete = false;
      this.$store
        .dispatch("notification/deleteNotification", this.deleteItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Benachrichtigung gelöscht",
            text: "Benachrichtigung wurde gelöscht"
          });
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Löschen fehlgeschlagen",
            text: "Benachrichtigung konnte nicht gelöscht werden."
          });
        });
    }
  },

  computed: {
    notificationList() {
      return this.$store.getters["notification/getNotificationList"];
    }
  },

  created() {
    this.loading = true;
    this.$store
      .dispatch("notification/fetchNotificationList")

      .then(() => {})
      .catch(error => {
        if (error.response.status != 401) {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
#Customerlistcard {
  margin: 20px;
}
</style>
